module.exports = __webpack_public_path__ + "static/media/police-badge.ef702f69.png";